export class Shape {
	stroke = { top: {}, right: {}, bottom: {}, left: {} };
	radius = { top: 0, right: 0, bottom: 0, left: 0 };
	fill = { rule: 'color', color: '', gradient: '' };
	position = { x: 0, y: 0 };
	size = { width: 0, height: 0 };
	rotation = 0;
	shadow = { blur: 0, color: '', offsetX: 0, offsetY: 0 };
	clip = false;

	id = '';

	constructor({ x = 0, y = 0, fillRule = 'color', fill = '', width = 0, height = 0, stroke = [0, ''], radius = 0, rotation = 0, shadow = {}, clip = false }) {
		Object.assign(this.size, { width, height });
		Object.assign(this.position, { x, y });
		this.fill.rule = fillRule;
		this.fill[fillRule] = fill;
		this.rotation = rotation;
		this.clip = clip
		Object.assign(this.shadow, shadow);
		this.applyStroke(stroke);
		this.applyRadius(radius);

		this.id = Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
	}

	applyStroke(stroke) {
		if (Array.isArray(stroke)) {
			Object.keys(this.stroke).forEach(side => {
				this.stroke[side].size = stroke[0];
				this.stroke[side].color = stroke[1]
			})
		} else if (typeof stroke === 'object') {
			Object.keys(stroke).forEach((side) => {
				if (Array.isArray(stroke[side])) {
					this.stroke[side].size = stroke[side][0];
					this.stroke[side].color = stroke[side][1]
				} else if (typeof stroke[side] === 'object') {
					this.stroke[side].size = stroke[side].size || 0;
					this.stroke[side].color = stroke[side].color || '';
				} else {
					throw new Error('Invalid type type of stroke side ' + side + '. Must be [size, color] or { size, color }')
				}
			})
		} else {
			throw new Error('Invalid type type of stroke. Must be [size, color] or { size, color }')
		}
	}

	applyRadius(radius) {
		if (Array.isArray(radius)) {
			if (radius.length === 2) {
				this.radius.top = radius[0];
				this.radius.bottom = radius[0];
				this.radius.right = radius[1];
				this.radius.left = radius[1];
			} else if (radius.length === 3) {
				this.radius.top = radius[0];
				this.radius.right = radius[1];
				this.radius.left = radius[1];
				this.radius.bottom = radius[2];
			} else if (radius.length === 4) {
				this.radius.top = radius[0];
				this.radius.right = radius[3];
				this.radius.bottom = radius[2];
				this.radius.left = radius[1];
			} else {
				throw new Error('Invalid type type of radius.')
			}
		} else if (typeof radius === 'object') {
			this.radius = {...this.radius, radius}
		} else if (typeof radius === 'number') {
			this.radius.top	= radius;
			this.radius.right = radius;
			this.radius.bottom = radius;
			this.radius.left = radius;
		} else {
			throw new Error('Invalid type type of radius.')
		}
	}

	applyStyles(context) {
		context.fillStyle = this.fill.color;
		context.shadowBlur = this.shadow.blur;
		context.shadowColor = this.shadow.color;
		context.shadowOffsetX = this.shadow.offsetX;
		context.shadowOffsetY = this.shadow.offsetY;
	}

	draw(context) {}

	beforeRestore(context) {}
}
